import { format } from 'date-fns';
import { openToastError } from '../use-cases/toast/useToast.tsx';

/**
 * downloadFile
 */
export const downloadFile = (data: string, name: string, extension: string, type: string = 'application/pdf') => {
  const dateDownload = format(new Date(), 'yyyyMMdd-hhmmss');
  const url = window.URL.createObjectURL(
    new Blob([data], {
      type,
    })
  );
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${name}_${dateDownload}.${extension}`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

/**
 * downloadCSV
 */
export const downloadCSV = (data: File, name: string) => {
  const dateDownload = format(new Date(), 'yyyyMMdd-hhmmss');
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${name}_${dateDownload}.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

/**
 * downloadPdf
 */
export const downloadPdf = (fileUrl: string, name: string) => {
  const dateDownload = format(new Date(), 'yyyyMMdd-hhmmss');
  const link = document.createElement('a');
  link.href = fileUrl;
  link.setAttribute('download', `${name}_${dateDownload}.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const downloadZip = (blobData: any, name: string) => {
  if (!blobData?.data?.['type'] || blobData.data?.['type'] !== 'application/zip') {
    openToastError(new Error('Failed to fetch zip file'));
    return;
  }
  if (blobData?.data) {
    downloadFile(blobData?.data, name, 'zip', 'application/zip');
  }
};
